import React from 'react';
import PropTypes from 'prop-types';

import { Link, withRouter } from 'react-router';

import PowerSwitchRow from '../DetailPageComponents/PowerSwitchRow.jsx';

import { getNamedRoot, mapUnit, formatValue, MAP_STATE_TO_CLASSNAME } from '../util/topic.js';

/**
 * Render one row for a grouping typed component. The topic and direct subtopics are already subscribed via push */



export class TypeGroupRow extends React.Component {

    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    static childContextTypes = {
        basePath: PropTypes.string
    }

    getChildContext() {
        return {
            basePath: ""
        };
    }

    sub = null;
    phaseSubs = [];
    nameSub = null;
    mapCurrentsToPhases = [];

    state = {};

    componentDidUpdate (prevProps) {
        if (prevProps.phaseMap !== this.props.phaseMap) {
            this.subscribePhases();
        }
    }

    subscribePhases (phaseMap) {
        for (let sub of this.phaseSubs) {
            this.context.p.unsubscribeDS(this.phaseUpdate, sub);
        }
        let update = {};

        for (let phase in this.props.phaseMap) {
            const path = this.props.phaseMap[phase] + "/Current";
            this.phaseSubs.push(this.context.p.subscribeDS(path, this.phaseUpdate));
            this.mapCurrentsToPhases[path] = phase;
            update[phase] = this.context.p.getPath(path);
        }
        this.setState(update);
    }

    componentDidMount() {
        const rootNameTopic = getNamedRoot(this.props.path);
        this.sub = this.context.p.subscribeDS(this.props.path, this.update);
        this.subtopicsSub = this.context.p.subscribeDS(this.props.path + "/+", this.subUpdate);
        let update = {
            parent: null,
            phase: null
        };
        if (rootNameTopic) {
            this.nameSub = this.context.p.subscribeDS(rootNameTopic, this.rootNameUpdate);
            const nameData = this.context.p.getPath(rootNameTopic);
            if (nameData && nameData.name) {
                update['rootName'] = nameData.name;
                update['rootState'] = nameData.state;
                update['rootAlarms'] = nameData.a;
                update['rootWarnings'] = nameData.w;
                update['rootType'] = nameData.type;
                update['uuid'] = rootNameTopic.split("/")[1];
            }
        }

        if (this.props.phaseMap) {
            this.subscribePhases();
        }

        update = Object.assign(update, this.context.p.getPath(this.props.path));
        this.setState(update);
    }

    componentWillUnmount() {
        this.context.p.unsubscribeDS(this.update, this.sub);
        this.context.p.unsubscribeDS(this.subUpdate, this.subtopicsSub);
        if (this.nameSub) {
            this.context.p.unsubscribeDS(this.rootNameUpdate, this.nameSub);
        }

        for (let sub of this.phaseSubs) {
            this.context.p.unsubscribeDS(this.phaseUpdate, sub);
        }
        this.nameSub = this.sub = this.subtopicsSub = this.phaseSubs = null;
    }

    update = (val, path, localPath) => {
        if (val) {
            const update = {};
            if (val.name) {
                update.name = val.name;
            }
            if (val.id) {
                update.id = val.id;
            }
            if (val.type) {
                update.type = val.type;
            }
            update.phase = val.phase;
            update.parent = val.parent;
            this.setState(update);
        }
    }

    rootNameUpdate = (val) => {
        if (val) {
            this.setState({"rootName": val.name, "rootState": val.state, "rootAlarms": val.a, "rootWarnings": val.w, "rootType": val.type});
        }
    }

    subUpdate = (val, path, localPath) => {
        const update = {};
        update[localPath] = this.context.p.getPath(this.props.path + "/" + localPath);
        this.setState(update);
    }

    phaseUpdate = (val, data, path, localPath, fullPath) => {
        const phase = this.mapCurrentsToPhases[fullPath];
        if (phase) {
            this.setState({[phase]: this.context.p.getPath(fullPath)});
        }
    }

    openChart = (topic, event) => {
        event.stopPropagation();
        if (event.target.nodeName.toLowerCase() === 'input') {
            return;
        }

        this.props.pushComponentCB("chart-" + encodeURIComponent(this.props.path + "/" + topic) + "?name=" + encodeURI(this.props.getPopupTitle(topic) || this.state.name));
    }

    onReportToggled = (topic, e) => {
        const isAdd = e.target.checked;
        this.props.changeReportTopic(isAdd, topic);
        e.stopPropagation();
    }

    onThresholdOpen = (path, e) => {
        this.props.showThresholdPopup(path);
        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    pushUuid = () => {
        if (this.state.uuid && this.props.pushCB) {
            this.props.pushCB("sensor;" + this.state.uuid);
        }
    }

    render() {
        const path = this.props.path;
        const cols = [];
        const self = this;
        let className;

        if (this.props.isMain) {
            let colSpan = 1;
            if (this.props.showInletNames) {
                colSpan++;
            }
            if (this.props.hasSensors) {
                colSpan++;
            }
            className = "line " + (this.props.hasSensors ? "" : MAP_STATE_TO_CLASSNAME[this.state.state]);
            cols.push((
                <td key="id-main" className={className} colSpan={colSpan}>{ this.state.name ? this.state.name : "--" }</td>
            ));
        } else {
            const indexReadable = this.state.id ? this.state.id : this.props.idx;
            cols.push((
                <td key="td-idx">{ indexReadable }</td>
            ));
            
            if (this.props.showInletNames) {
                className = this.props.hasSensors ? null : MAP_STATE_TO_CLASSNAME[this.state.state];
                cols.push((
                    <td key="td-name" className={className}>{ this.state.name ? this.state.name : "--" }</td>
                ));
            }

            if (this.props.hasSensors) {
                // Render number of alarms and/or warnings of sensor root
                let alarms = null;

                if (this.state.rootAlarms?.length || this.state.rootWarnings?.length) {
                    const alarmCount = (this.state.rootAlarms ? this.state.rootAlarms.length : 0);
                    const warningCount = (this.state.rootWarnings ? this.state.rootWarnings.length : 0);
                    if (alarmCount > 0) {
                        className = "critical";
                    } else if (warningCount > 0) {
                        className = "warning";
                    } else {
                        className = MAP_STATE_TO_CLASSNAME[this.state.rootState];
                    }
                } else {
                    className = MAP_STATE_TO_CLASSNAME[this.state.rootState];
                }

                cols.push((
                    <td key="td-rootName" className={className} onClick={this.pushUuid}>{ this.state.rootName ? this.state.rootName : "--" }</td>
                ));
            }
        }

        for (let i in this.props.topics) {
            let topic = this.props.topics[i];
            const originalTopic = topic;

            // Check if we only render a certain type
            if (this.props.onlyShowType) {
                topic = "val";
                if (this.props.onlyShowType !== originalTopic) {
                    cols.push((
                        <td key={"td-" + originalTopic}>&nbsp;</td>
                    ));
                    continue;
                }
            }

            if (this.props.isMain && topic === "val") {
                topic = "TEMPERATURE";
            }
            let currentVal = formatValue(topic, this.state[topic], true);
            
            if (topic === "val" && path.indexOf("sensor/") === 0 && !this.props.isMain) {
                const sensorParent = this.context.p.getPath(path);
                if (sensorParent) {
                    currentVal += this.context.t("sensor_units." + sensorParent.unit);
                }
            }

            let fullPath;

            // If we can map phases to other inlets and this is a phase, take this as fullpath
            if (this.props.phaseMap && this.props.phaseMap[topic]) {
                fullPath = this.props.phaseMap[topic] + "/Current";
                topic = "Current";
            } else {
                fullPath = path + "/" + topic;
            }

            className = "text-right";
            if (this.state.a && this.state.a.indexOf(fullPath) !== -1) {
                className += " critical";
            } else if (this.state.w && this.state.w.indexOf(fullPath) !== -1) {
                className +=  "warning";
            }

            if (this.props.isMain) {
                className += " line";
            }
            
            let colContents, configButton;
            const isSwitch = topic === "switch";

            if (isSwitch) {
                colContents = <PowerSwitchRow readOnly={false} dataPath={path + "/" + topic} />;
            } else {
                // if (this.thresholdSerial !== this.context.thresholdSerial) {
                //     this.threshold = getThreshold(fullPath, this.context.p);
                // }
                // let thresholdClasses = "fa fa-sliders";
                // if (this.threshold?.thr) {
                    
                //     const hasSpecificRule = this.threshold?.path === fullPath;

                //     if (hasSpecificRule) {
                //         thresholdClasses += " hasown";
                //     } else {
                //         thresholdClasses += " hasrule";
                //     }
                //     configButton = (
                //         <span className={thresholdClasses}></span>
                //     );
                // }

                const alertIdx = this.state?.a?.indexOf(fullPath);
                const isAlerted = alertIdx !== undefined && alertIdx !== -1;
                let isWarned = false;
                if (!isAlerted) {
                    const warnIdx = this.state?.w?.indexOf(fullPath);
                    isWarned = warnIdx !== undefined && warnIdx !== -1;
                }

                if (isAlerted) {
                    className += " critical";
                } else if (isWarned) {
                    className += " warning";
                }

                if (this.props.isCreatingReport) {
                    const fullPath = path + "/" + topic;
                    const checked = this.props.reportTopics && this.props.reportTopics.indexOf(fullPath) !== -1;
                    colContents = <>
                        <input type="checkbox" checked={checked} onChange={self.onReportToggled.bind(self, fullPath)}/>&nbsp;&nbsp;{currentVal}
                    </>;
                } else {
                    colContents = currentVal;
                }
            }

            cols.push((
                <td key={"td-" + originalTopic} onClick={!isSwitch && this.openChart.bind(this, topic)} className={className}><span>{ colContents }{mapUnit[topic] ? mapUnit[topic] : ""}</span>{ configButton }</td>
            ));
        }
        return (
            <tr key={"tr-" + this.props.path}>
                {cols}
            </tr>
        );
    }
}

TypeGroupRow.propTypes = {
    idx: PropTypes.number,
    isMain: PropTypes.bool,
    topics: PropTypes.array.isRequired,
    pushCB: PropTypes.func,
    pushComponentCB: PropTypes.func.isRequired,
    getPopupTitle: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    hasSensors: PropTypes.bool.isRequired,
    isCreatingReport: PropTypes.bool.isRequired,
    changeReportTopic: PropTypes.func.isRequired,
    reportTopics: PropTypes.array,
    showThresholdPopup: PropTypes.func.isRequired,
    onlyShowType: PropTypes.string
};